import Navbar from "@/components/home/Navbar";
import Footer from "@/components/home/Footer";

const sections = [
    {
        title: "Éditeur du site",
        body: [
            "Le présent site est édité par La Petite Lunetterie.",
            "Adresse : 7 place Edgar Quinet, 01000 Bourg-en-Bresse, France.",
            "Téléphone : 04 74 22 71 44.",
            "Email : contact@lapetitelunetterie.fr.",
            "SIRET : à compléter.",
            "Directrice de la publication : Sylvie, gérante.",
        ],
    },
    {
        title: "Hébergement",
        body: [
            "Le site est hébergé par un prestataire technique tiers. Les coordonnées complètes de l'hébergeur seront précisées ici.",
        ],
    },
    {
        title: "Propriété intellectuelle",
        body: [
            "L'ensemble des contenus présents sur ce site (textes, images, identité visuelle, logos, vidéos) sont la propriété exclusive de La Petite Lunetterie ou de leurs auteurs respectifs.",
            "Toute reproduction, représentation, modification ou exploitation, totale ou partielle, est interdite sans autorisation préalable écrite.",
        ],
    },
    {
        title: "Conception du site",
        body: [
            "Site conçu et réalisé par Axeris Labs (axeris-labs.fr).",
        ],
    },
    {
        title: "Crédits photos",
        body: [
            "Les photographies de la boutique et de l'équipe sont la propriété de La Petite Lunetterie.",
        ],
    },
    {
        title: "Contact",
        body: [
            "Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter à l'adresse contact@lapetitelunetterie.fr ou par courrier postal à l'adresse mentionnée ci-dessus.",
        ],
    },
];

export default function MentionsLegales() {
    return (
        <div
            className="min-h-screen font-body bg-lpl-bg text-lpl-text"
            data-testid="mentions-page"
        >
            <Navbar />
            <main className="pt-24 md:pt-28 pb-20">
                <section className="max-w-3xl mx-auto px-5 md:px-10 py-12">
                    <p className="font-serif italic text-2xl md:text-3xl text-lpl-terracotta mb-4">
                        Les petites lignes
                    </p>
                    <h1
                        className="font-display font-semibold text-5xl md:text-7xl text-lpl-text leading-[0.95] tracking-tight mb-12"
                        data-testid="mentions-title"
                    >
                        Mentions{" "}
                        <span className="font-serif italic font-normal text-lpl-primary-deep">
                            légales
                        </span>
                        <span className="font-serif italic font-normal text-lpl-lavender">
                            .
                        </span>
                    </h1>

                    <div className="space-y-12">
                        {sections.map((s) => (
                            <article key={s.title}>
                                <h2 className="font-display font-semibold text-2xl md:text-3xl text-lpl-text leading-tight tracking-tight mb-4">
                                    {s.title}
                                </h2>
                                <div className="space-y-3 text-lpl-text-muted text-base md:text-lg leading-relaxed">
                                    {s.body.map((p, i) => (
                                        <p key={i}>{p}</p>
                                    ))}
                                </div>
                            </article>
                        ))}
                    </div>

                    <p className="mt-16 text-xs uppercase tracking-[0.18em] text-lpl-text-muted">
                        Dernière mise à jour : février 2026
                    </p>
                </section>
            </main>
            <Footer />
        </div>
    );
}
